import { Flex, Button, SvgIcon } from '@volue/wave-react';
import React from 'react';
import type { FallbackProps } from 'react-error-boundary';

import { InlineNotification } from '@/features/execute-calculation-set/components/Calculation/InlineNotification';

export const ErrorPage: React.FunctionComponent<{
  message: string;
  fallbackProps: FallbackProps;
}> = props => (
  <div className="h100 w100 jcC aiC beta fdC pHxl mHxl">
    <InlineNotification
      type="ERROR"
      className="mAl"
      content={props.message}
      actionButtons={[
        <Flex
          flow="column"
          css={{
            justifyContent: 'space-between',
            textAlign: 'center',
            fontSize: 'small'
          }}
        >
          <Button
            className="w100"
            data-testid="run-calculation-set-btn"
            leftIcon={<SvgIcon iconName="play" />}
            onClick={props.fallbackProps.resetErrorBoundary}
          >
            {'Try again'}
          </Button>
        </Flex>
      ]}
    />
  </div>
);
